
// Constants

import { BLOOD_RELATIONSHIP_CODES } from '@constants/ssap/hhmTypes/bloodRelationshipCodesList';

export const getMarriageStatus = (personId, bloodRelationship) => {

    return bloodRelationship
        .filter(r => r.individualPersonId === String(personId))
        .some(r => r.relation === BLOOD_RELATIONSHIP_CODES.SPOUSE);

};